const API_URI = process.env.REACT_APP_API_URI || "http://localhost:5000/api/v1";

export { API_URI };
